<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="{'modal--wider' : wider}">
          <div class="modal-body">
            <div class="modal-header">
              <h2>{{title}}</h2>
            </div>
            <div class="body-msg">
              <slot></slot>
            </div>
            <div class="footer">
              <transition enter-active-class="animated shake">
                <p class="error" v-if="errorMessage.length>0">{{ errorMessage }}</p>
              </transition>
              <button type="submit" class="btn btn-danger btn--mod" @click="$emit('close')">Otkaži</button>
              <button
                type="submit"
                class="btn btn-primary btn--mod"
                :disabled="error || isLoading"
                @click="$emit('confirm')"
              >
                <div v-if="!isLoading">{{ confirm }}</div>
                <div v-else>
                  <spinner size="20" line-fg-color="#00796b" class="spinner"></spinner>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    error: { type: Boolean },
    message: { type: String, required: false },
    confirm: { type: String, default: 'Potvrdi' },
    errorMessage: { type: String, default: '' },
    wider: { type: Boolean, default: false },
    title: { type: String, default: 'Potvrda' },
    isLoading: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: absolute;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  /*width: 600px;*/
  width: 700px;
  margin: 0px auto;
  padding: 15px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-header {
  padding-top: 0px !important;
  padding-left: 0px !important;
}

.body-msg {
  padding: 1rem 0;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 1rem;
}

.modal-body {
  padding-top: 10px;
  // margin: 20px 0;
  // margin-bottom: 10px;
  max-height: calc(100vh - 110px);
  // padding-left: 3px !important;
  overflow-y: auto;
}

.modal--wider {
  width: 75vw;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.footer {
  button {
    height: 40px;
    min-width: 75px;
  }
  .buttons {
    text-align: right !important;
  }

  .error {
    color: red;
    position: absolute;
  }
}
</style>
